import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { MenuButton } from "@szhsin/react-menu"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"
import * as API from "services/api"
import { errorToast, successToast } from "shared/toast"
import Tooltip from "shared/Tooltip"

const GroupMenu = ({ group, removeGroup }) => {
  const { id } = group

  const deleteGroup = async () => {
    const response = await API.deleteGroup({ groupId: group.id })

    if (response.ok) {
      removeGroup(group.id)
      successToast("Group deleted successfully.")
    } else {
      errorToast("Something went wrong. Unable to delete group.")
    }
  }

  const deletable = !group.hasWorkflows
  const message = deletable ? "" : "Groups used in workflows cannot be deleted."

  return (
    <ExpandMenu
      expandMenuComponent={(
        <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
          <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
        </MenuButton>
      )}
    >
      <ExpandMenuItem href={`/admin/groups/${id}`}>
        Edit
      </ExpandMenuItem>
      <Tooltip text={message}>
        <ExpandMenuItem
          className={clsx(!deletable && "cursor-not-allowed")}
          disabled={!deletable}
          onClick={deleteGroup}
        >
          Delete
        </ExpandMenuItem>
      </Tooltip>
    </ExpandMenu>
  )
}

GroupMenu.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  group: types.object.isRequired,
  removeGroup: types.func.isRequired,
}

export default GroupMenu
